<template>
  <card-component title="Resumen Jueces" subtitle="Jueces que evaluadores" class="has-table has-mobile-sort-spaced" >
    <div slot="headerRight" class="card-header-icon">
        <div class="buttons">
            <b-button type="is-primary" @click="downloadClick" :loading="isLoadingDownload"><b-icon icon="file-download"></b-icon></b-button>
        </div>
      </div>
    <b-table
            ref="table"
            slot="content"
            :data="judges"
            :bordered="true"
            :striped="true"
            :show-detail-icon="true"
            detailed
            :sticky-header="true"
            @click="toggle"
            class="table-height"
            :loading="isLoading">

            <template slot-scope="props">
                <b-table-column label="#" width="40" numeric centered class="'is-sticky-column-one'">
                    {{props.index + 1}}
                </b-table-column>

                <b-table-column field="name" label="Nombre">
                  {{ `${props.row.name} ${props.row.lastname}` }}
                </b-table-column>

                <b-table-column field="type" width="150"  label="Tipo" centered>
                  {{ props.row.official ? 'Oficial' : 'No Oficial' }}
                  <b-icon
                    v-if="props.row.official"
                    style="margin-left: 0rem;"
                      icon="star"
                      size="is-small">
                  </b-icon>
                </b-table-column>

                <b-table-column field="duration" label="Duración" centered>
                    {{ props.row.duration }}
                </b-table-column>

                <b-table-column field="errors" label="Errores" centered>
                  {{ props.row.errors }}
                </b-table-column>

                <b-table-column field="pts" label="Puntaje" centered>
                  {{ `${props.row.total} pts` }}
                </b-table-column>

                <b-table-column field="score" label="Nota" centered>
                  {{ `${props.row.final_score.toFixed(2)}%` }}
                </b-table-column>
                <b-table-column centered>
                  <b-button type="is-success" size="is-small" icon-left="pencil" @click.stop="editResults(props.row)">editar</b-button>
                </b-table-column>
            </template>

            <template slot="detail" slot-scope="props">
              <p><b>Observación General</b></p>
              <p>{{props.row.observation ? props.row.observation : 'Sin observación.'}}</p>
            </template>

            <section class="section" slot="empty">
              <div class="content has-text-grey has-text-centered">
                <template v-if="isLoading">
                  <p>
                    <b-icon icon="dots-horizontal" size="is-large" />
                  </p>
                  <p>Cargando datos...</p>
                </template>
                <template v-else>
                  <p>
                    <b-icon icon="horseshoe" size="is-large" />
                  </p>
                  <p>No hay datos&hellip;</p>
                </template>
              </div>
            </section>
        </b-table>
  </card-component>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import ExecutionService from '@/services/ExecutionService'

export default {
  props: {
    executionId: {
      required: true
    },
    execution: {
      required: true
    },
    evaluation: {
      required: true
    },
    selectedJudge: {
      required: false,
      default: null
    }
  },
  components: {
    CardComponent
  },
  created () {
    this.mapJudges()
  },
  data () {
    return {
      judges: [],
      isLoading: false,
      isLoadingDownload: false
    }
  },
  methods: {
    editResults (row) {
      this.$emit('update:selectedJudge', row)
    },
    toggle (row) {
      this.$refs.table.toggleDetails(row)
    },
    async downloadClick () {
      this.isLoadingDownload = true
      let playload = await this.downloadExecutionResults()
      let fileName = `${this.eventName}_${this.binominalName}.pdf`
      this.generateFile(playload, fileName, 'application/pdf')
      this.openAlert()
      this.isLoadingDownload = false
    },
    openAlert () {
      this.$buefy.notification.open({
        duration: 4000,
        icon: 'account',
        message: `<icon class="mdi mdi-24px mdi-download"></icon> La descarga comenzará dentro de poco`,
        position: 'is-bottom-left',
        type: 'is-info',
        hasIcon: false
      })
    },
    async mapJudges () {
      this.isLoading = true
      let judges = await this.getJudgesInresults()
      let resultJudges = await this.getJudgesResultsExecutions()

      this.judges = judges.map((judge, index) => {
        let judgeResult = this.findResult(judge.id, resultJudges)
        return {
          ...judge,
          ...judgeResult
        }
      })
      this.isLoading = false
    },
    findResult (id, array) {
      let result = array.find((x) => x.judge_id === id)
      if (result) {
        return {
          'total': result.total,
          'subtotal': result.subtotal,
          'errors': result.errors,
          'duration': result.duration,
          'observation': result.observation
        }
      } else {
        return {}
      }
    },
    async getJudgesInresults () {
      let response = await ExecutionService.getJudgesInresults(this.executionId)
      return response.data.data
    },
    async getJudgesResultsExecutions () {
      let response = await ExecutionService.getJudgesResultsExecutions(this.executionId)
      return response ? response.data.data : []
    },
    async downloadExecutionResults () {
      let response = await ExecutionService.downloadExecutionResults(this.executionId)
      return response.data
    },
    async generateFile (data, fileName, fileType) {
      var blob = new Blob([data], { type: fileType })
      var fileURL = window.URL.createObjectURL(blob)
      var fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', fileName)
      document.body.appendChild(fileLink)
      fileLink.click()
    }
  },
  computed: {
    binominalName () {
      let name = ''
      if (this.execution != null) {
        let horse = this.execution.horse
        let rider = this.execution.rider
        name = `${rider.lastname}_${rider.name}_${horse.name}`
      }
      return name
    },
    eventName () {
      let event = this.evaluation ? `Evaluación_${this.evaluation.start_date}` : ''
      return event
    }
  }
}
</script>

<style scoped>
 .table-height{
   max-height: 200px !important;
   overflow-y: auto !important;
 }
</style>
